module.exports = __webpack_public_path__ + "static/media/3playerRoomsPlayed_50000_75000.1a62df33.png";